export default [
  {
    id: 'extension-vip',
    name: 'Gói Vip 1 tháng',
    plan: 'ExtensionVip',
    title: 'Gói Vip 1 tháng',
    subTitle: '',
    price: 120000,
    beforePrice: 0,
    totalMonths: 1,
    description: ['Không có khuyến mãi'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/extension-vip.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'extension-vip-6',
    name: 'Gói Vip 6 tháng',
    plan: 'ExtensionVip',
    title: 'Gói Vip 6 tháng',
    subTitle: '',
    price: 720000,
    beforePrice: 840000,
    totalMonths: 7,
    description: ['Tặng 1 tháng'],
    promotion: ['Tặng 100 Sao chép Lazada & 100 Tiktok (trị giá 200k)'],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/extension-vip.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'extension-vip-12',
    name: 'Gói Vip 12 tháng',
    plan: 'ExtensionVip',
    title: 'Gói Vip 12 tháng',
    subTitle: '',
    price: 1440000,
    beforePrice: 1920000,
    totalMonths: 16,
    description: ['Tặng 4 tháng'],
    promotion: ['Tặng 300 Sao chép Lazada & 300 Tiktok (trị giá 400k)'],
    hotPrice: 'Chỉ 90k/tháng',
    bestChoice: true,
    logo: '/img/extension-vip.png',
    badge: '★ GIÁ TỐT NHẤT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'extension-plus',
    name: 'Gói VipPlus 1 tháng',
    plan: 'ExtensionPlus',
    title: 'Gói VipPlus 1 tháng',
    subTitle: '',
    price: 150000,
    beforePrice: 0,
    totalMonths: 1,
    description: ['Gói cao cấp'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/extension-plus.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'extension-plus-6',
    name: 'Gói VipPlus 6 tháng',
    plan: 'ExtensionPlus',
    title: 'Gói VipPlus 6 tháng',
    subTitle: '',
    price: 900000,
    beforePrice: 1050000,
    totalMonths: 7,
    description: ['Tặng 1 tháng', 'Gói cao cấp'],
    promotion: ['Tặng 100 Sao chép Lazada & 100 Tiktok (trị giá 200k)'],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/extension-plus.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'extension-plus-12',
    name: 'Gói VipPlus 12 tháng',
    plan: 'ExtensionPlus',
    title: 'Gói VipPlus 12 tháng',
    subTitle: '',
    price: 1800000,
    beforePrice: 2400000,
    totalMonths: 16,
    description: ['Tặng 4 tháng', 'Gói cao cấp'],
    promotion: ['Tặng 300 Sao chép Lazada & 300 Tiktok (trị giá 400k)'],
    hotPrice: 'Chỉ 113k/tháng',
    bestChoice: true,
    logo: '/img/extension-plus.png',
    badge: '★ GIÁ TỐT NHẤT',
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];
